import { useTranslation } from "@redotech/redo-i18n";
import { Provider } from "@redotech/redo-order-common/provider";
import type { PlatformState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { platformMap } from "@redotech/redo-return-ui/flows/return-flow/condition-types/platform";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

const platformToProvider: Record<string, Provider> = {
  Shopify: Provider.SHOPIFY,
  "Comment Sold": Provider.COMMENTSOLD,
  "Commerce Cloud": Provider.COMMERCE_CLOUD,
};

export const PlatformDetails = memo(function PlatformDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<PlatformState>) {
  const { t } = useTranslation();
  const platformOptions: RedoListItem<string>[] = useMemo(
    () =>
      [...platformMap.values()].map((platform) => ({
        id: platform,
        value: platform,
        type: "text" as const,
        text:
          platform === "Shopify"
            ? "Shopify"
            : platform === "Comment Sold"
              ? "Comment Sold"
              : t("Commerce Cloud"),
      })),
    [t],
  );

  const selectedPlatform = state
    ? platformOptions.find((option) => option.value === platformMap.get(state))
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      disabled={disabled}
      flexGrow
      label={t("Platform")}
      options={platformOptions}
      optionSelected={({ item }) => {
        const provider = platformToProvider[item.value];
        setState(provider ?? null);
      }}
      placeholder={t("Select platform...")}
      selectedItem={selectedPlatform}
      size="xs"
    />
  );
});
